const MichaelFinnegan = [
	'[Verse 1]',
	'There was an old man named Michael Finnegan',
	'He grew whiskers on his chin-igan',
	'The wind came up and blew them in again',
	'Poor old Michael Finnegan, begin again',
	'',
	'[Verse 2]',
	'There was an old mad named Michael Finnegan',
	'He fell down and broke his shin-igan',
	'Folks said, “Mike, you’ll never swim again”',
	'Poor old Michael Finnegan, begin again',
	'',
	'[Verse 3]',
	'There was an old man named Michael Finnegan',
	'He grew fat and then grew thin again',
	'Thinner than a safety pin-igan',
	'Poor old Michael Finnegan, begin again',
	'',
	'[Verse 4]',
	'There was an old man named Michael Finnegan',
	'He went fishing with a pin again',
	'Caught a fish but dropped it in again',
	'Poor old Michael Finnegan, begin again',
	'',
	'[Verse 5]',
	'There was an old man named Michael Finnegan',
	'He grew whiskers on his chin-igan',
	'The wind came up and blew them in again',
	'Poor old Michael Finnegan',
];

export default MichaelFinnegan;
